import { Component, OnInit } from '@angular/core';
import { PrimeNG } from 'primeng/config';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  menuMode = 'drawer';

  colorScheme = 'light';

  menuTheme = 'layout-sidebar-dark';

  inputStyle = 'filled';

  cardStyle = 'filled';

  ripple: boolean;

  constructor(
    private primengConfig: PrimeNG
  ) {
  }

  ngOnInit() {
    this.primengConfig.ripple.set(true);
  }
}
